// extracted by mini-css-extract-plugin
export default {"germanVATInc":"GqbG1V1 ZHWKoMf leavesden3"};